
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iIQbF", function(module, exports) {
/* AIFloatingContextMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag React.Fragment */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3ricL = parcelRequire("3ricL");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $ExetK = parcelRequire("ExetK");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3Am3T = parcelRequire("3Am3T");


var $NomII = parcelRequire("NomII");


var $bQm3c = parcelRequire("bQm3c");


var $7mpOv = parcelRequire("7mpOv");


var $8zMP3 = parcelRequire("8zMP3");


var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");








var $9ivsj = parcelRequire("9ivsj");

const $af25143620373faf$var$baseShadow = `0 0 0 2px ${"var(--ds-border-brand, #1868DB)"}`;
const $af25143620373faf$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $af25143620373faf$var$pulseKeyframes = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$SinglePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$DoublePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$defaultBorderRadius = null;
const $af25143620373faf$var$isInObjectSideBarBorderRadius = null;
const $af25143620373faf$export$cd20eff28c3c2c7f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, pulseCount: t1, isInObjectSideBar: t2 } = t0;
    const pulseCount = t1 === undefined ? 0 : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) {
        let t3;
        if ($[0] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "contextual-pulse-none"
            }, children);
            $[0] = children;
            $[1] = t3;
        } else t3 = $[1];
        return t3;
    }
    switch(pulseCount){
        case 1:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[2] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[2] = t3;
                    $[3] = t4;
                } else t4 = $[3];
                let t5;
                if ($[4] !== children || $[5] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                        "data-testid": "contextual-pulse-single",
                        className: t4
                    }, children);
                    $[4] = children;
                    $[5] = t4;
                    $[6] = t5;
                } else t5 = $[6];
                return t5;
            }
        case 2:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[7] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[7] = t3;
                    $[8] = t4;
                } else t4 = $[8];
                let t5;
                if ($[9] !== children || $[10] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                        "data-testid": "contextual-pulse-double",
                        className: t4
                    }, children);
                    $[9] = children;
                    $[10] = t4;
                    $[11] = t5;
                } else t5 = $[11];
                return t5;
            }
    }
    let t3;
    if ($[12] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "contextual-pulse-none"
        }, children);
        $[12] = children;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ children: children, pulseCount: pulseCount = 0, isInObjectSideBar: isInObjectSideBar = false })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
    switch(pulseCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                "data-testid": "contextual-pulse-single",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                "data-testid": "contextual-pulse-double",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
};















var $41KFX = parcelRequire("41KFX");








var $55fM8 = parcelRequire("55fM8");

const $5d003355575f53c0$export$cbb5dd4e54f3bea9 = (isLivePage = false)=>{
    {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const newViewPageContainer = document.getElementById('AkMainContent');
        const [scrollHeightAttributes, setScrollHeightAttributes] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useState)({
            scrollY: 0
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleScroll = (0, $cozmU.useCallback)(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const viewPageScrollY = newViewPageContainer ? newViewPageContainer.scrollTop : window.scrollY;
            setScrollHeightAttributes({
                scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY
            });
        }, [
            setScrollHeightAttributes,
            isLivePage,
            newViewPageContainer
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useEffect)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handleScroll, 250);
            if (isLivePage) livePageContainer?.addEventListener('scroll', debounceScroll);
            else newViewPageContainer ? newViewPageContainer?.addEventListener('scroll', debounceScroll) : document.addEventListener('scroll', debounceScroll);
            return ()=>{
                if (isLivePage) livePageContainer?.removeEventListener('scroll', debounceScroll);
                else newViewPageContainer ? newViewPageContainer?.removeEventListener('scroll', debounceScroll) : document.removeEventListener('scroll', debounceScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return scrollHeightAttributes;
    }
};



var $72md5 = parcelRequire("72md5");

var $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf = /*#__PURE__*/ function(FeatureStates) {
    FeatureStates["QuickSummary"] = "quick-summary";
    FeatureStates["Comments"] = "comments";
    FeatureStates["PageCatchup"] = "page-catchup";
    FeatureStates["BulkIssueCreate"] = "bulk-issue-create";
    FeatureStates["QuickSummaryAudio"] = "quick-summary-audio";
    return FeatureStates;
}({});
var $2c4fc9e48b4f3b02$export$a913d22899a46b83 = /*#__PURE__*/ function(NonFeatureStates) {
    NonFeatureStates["Menu"] = "menu";
    NonFeatureStates["OptIn"] = "opt-in";
    NonFeatureStates["Upsell"] = "upsell";
    return NonFeatureStates;
}({});
const $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c = {
    ...$2c4fc9e48b4f3b02$export$881f3bfeb53afdcf,
    ...$2c4fc9e48b4f3b02$export$a913d22899a46b83
};
function $2c4fc9e48b4f3b02$export$4940a8f6968b63(popupState) {
    return Object.values($2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).includes(popupState);
}



var $i1vUz = parcelRequire("i1vUz");

const $83cf8da53844c2d7$export$7571cdd921b49cc0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType, pageCommentsSectionInView, isLivePage, contentIdFromQuery, contentBodyDynamic)=>{
    const $ = (0, $bDgLe.c)(9);
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { navStyle: navStyle } = (0, $41KFX.useSimplifiedNavNewUsers)();
    const isSimplifiedNavExperimentVariant = navStyle === "default-templates" || navStyle === "pin-templates";
    const hasContentToSummarize = isSimplifiedNavExperimentVariant ? (0, $72md5.docHasContent)(contentBodyDynamic) : true;
    if (!isAdminHubAIEnabled) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: null
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
            };
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) {
        let t0;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
            };
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    if (scrollY !== null && scrollY < 400) {
        if (isSimplifiedNavExperimentVariant) {
            const canUseSyncBlankCheck = contentIdFromQuery != null && contentBodyDynamic !== undefined && contentId === contentIdFromQuery;
            if (canUseSyncBlankCheck && !hasContentToSummarize) {
                let t0;
                if ($[3] !== queryError) {
                    t0 = {
                        dynamicActionTarget: null,
                        queryError: queryError
                    };
                    $[3] = queryError;
                    $[4] = t0;
                } else t0 = $[4];
                return t0;
            }
        }
        let t0;
        if ($[5] !== queryError) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
                queryError: queryError
            };
            $[5] = queryError;
            $[6] = t0;
        } else t0 = $[6];
        return t0;
    }
    let t0;
    if ($[7] !== queryError) {
        t0 = {
            dynamicActionTarget: null,
            queryError: queryError
        };
        $[7] = queryError;
        $[8] = t0;
    } else t0 = $[8];
    return t0;
} : (contentId, contentType, pageCommentsSectionInView, isLivePage, contentIdFromQuery, contentBodyDynamic)=>{
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { navStyle: navStyle } = (0, $41KFX.useSimplifiedNavNewUsers)();
    const isSimplifiedNavExperimentVariant = navStyle === 'default-templates' || navStyle === 'pin-templates';
    // contentBodyDynamic is passed through from the view-page query (same ref when data unchanged), so this memo is stable.
    const hasContentToSummarize = (0, $cozmU.useMemo)(()=>isSimplifiedNavExperimentVariant ? (0, $72md5.docHasContent)(contentBodyDynamic) : true, [
        isSimplifiedNavExperimentVariant,
        contentBodyDynamic
    ]);
    if (!isAdminHubAIEnabled) return {
        dynamicActionTarget: null
    };
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
    };
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
    };
    if (scrollY !== null && scrollY < 400) {
        if (isSimplifiedNavExperimentVariant) {
            const canUseSyncBlankCheck = contentIdFromQuery != null && contentBodyDynamic !== undefined && contentId === contentIdFromQuery;
            if (canUseSyncBlankCheck && !hasContentToSummarize) return {
                dynamicActionTarget: null,
                queryError: queryError
            };
        }
        return {
            dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
            queryError: queryError
        };
    }
    return {
        dynamicActionTarget: null,
        queryError: queryError
    };
};












var $ivb8S = parcelRequire("ivb8S");


var $d282Z = parcelRequire("d282Z");







const $874fd8abb2c90fe4$export$b938e63de8ec6cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType)=>{
    const $ = (0, $bDgLe.c)(10);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    let t0;
    let t1;
    if ($[0] !== dynamicSplitButtonLoading || $[1] !== isAdminHubAIEnabled || $[2] !== onboardingStateData || $[3] !== onboardingStateLoading || $[4] !== setOnboardingState || $[5] !== showCatchupAsDefault) {
        t0 = ()=>{
            if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
                hasLoaded.current = true;
                const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
                if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                    setOnboardingState({
                        key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                        value: "true"
                    });
                    setPulseCount(2);
                } else if (showCatchupAsDefault) setPulseCount(1);
            }
        };
        t1 = [
            dynamicSplitButtonLoading,
            onboardingStateData,
            onboardingStateLoading,
            setPulseCount,
            setOnboardingState,
            showCatchupAsDefault,
            isAdminHubAIEnabled
        ];
        $[0] = dynamicSplitButtonLoading;
        $[1] = isAdminHubAIEnabled;
        $[2] = onboardingStateData;
        $[3] = onboardingStateLoading;
        $[4] = setOnboardingState;
        $[5] = showCatchupAsDefault;
        $[6] = t0;
        $[7] = t1;
    } else {
        t0 = $[6];
        t1 = $[7];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[8] !== pulseCount) {
        t2 = {
            pulseCount: pulseCount
        };
        $[8] = pulseCount;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (contentId, contentType)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    // Ignoring error state as we will just not show a pulse if this errors
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    (0, $cozmU.useEffect)(()=>{
        if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
            // We only want this to execute once and only once when both hooks are finished loading
            hasLoaded.current = true;
            const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
            if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                    value: 'true'
                });
                setPulseCount(2);
            } else if (showCatchupAsDefault) setPulseCount(1);
        }
    }, [
        dynamicSplitButtonLoading,
        onboardingStateData,
        onboardingStateLoading,
        setPulseCount,
        setOnboardingState,
        showCatchupAsDefault,
        isAdminHubAIEnabled
    ]);
    return {
        pulseCount: pulseCount
    };
};















var $1sCHt = parcelRequire("1sCHt");





var $kA6Zo = parcelRequire("kA6Zo");


var $kz1Yj = parcelRequire("kz1Yj");





var $kh0hi = parcelRequire("kh0hi");


var $iODl6 = parcelRequire("iODl6");


var $57p4j = parcelRequire("57p4j");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



var $320o0 = parcelRequire("320o0");

const $e926aed382b01d25$export$2c6a5235f6e9fe39 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });



var $e4o8D = parcelRequire("e4o8D");

const $7b40fa145aa0c9d8$var$i18n = (0, $kSwu1.defineMessages)({
    logoAltText: {
        id: "ai-floating-context-menu.floating-context-menu-button.logo-alt-text",
        defaultMessage: "Atlassian Intelligence"
    }
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.075',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised'
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $7b40fa145aa0c9d8$var$dividerStyles = (0, $buxP3.xcss)({
    height: '100%',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar = (0, $buxP3.xcss)({
    height: '24px',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$defaultPressableStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle',
    borderRadius: 'radius.small',
    transition: 'background 0.1s ease-out',
    whiteSpace: 'nowrap',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        pointerEvents: 'none',
        position: 'absolute'
    },
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $7b40fa145aa0c9d8$var$selectedPressableStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected',
        borderStyle: 'solid'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-hovered, #CFE1FD)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-pressed, #8FB8F6)"
    }
});
const $7b40fa145aa0c9d8$var$sideBarPressableStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    paddingBlock: 'space.075'
});
const $7b40fa145aa0c9d8$export$c226a072142c15e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { dynamicActionText: dynamicActionText, isDynamicActionSelected: t1, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: t2 } = t0;
    const isDynamicActionSelected = t1 === undefined ? false : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t3 = !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles;
    const t4 = isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = [
            t3,
            t4
        ];
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = !renderServerPlaceholder;
    let t7;
    if ($[3] !== dynamicActionText || $[4] !== isDynamicActionSelected || $[5] !== isInObjectSideBar || $[6] !== onDynamicActionClick) {
        t7 = dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "right",
            exitDirection: "right",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                "data-vc": "ai-floating-dynamic-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                onClick: ()=>onDynamicActionClick?.(),
                xcss: [
                    $7b40fa145aa0c9d8$var$defaultPressableStyles,
                    isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                    isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles
                ]
            }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
            ]
        }));
        $[3] = dynamicActionText;
        $[4] = isDynamicActionSelected;
        $[5] = isInObjectSideBar;
        $[6] = onDynamicActionClick;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: t6,
            exitThenEnter: true
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== onMenuButtonClick) {
        t10 = ()=>onMenuButtonClick?.();
        $[13] = onMenuButtonClick;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = isInObjectSideBar ? "circle" : "default";
    let t12;
    if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
            label: t9,
            onClick: t10,
            appearance: "subtle",
            isSelected: isMenuOpen,
            shape: t11
        });
        $[15] = isMenuOpen;
        $[16] = t10;
        $[17] = t11;
        $[18] = t9;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== t12 || $[21] !== t5 || $[22] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: t5,
            grow: "hug",
            space: "space.050",
            alignBlock: "center"
        }, t8, t12);
        $[20] = t12;
        $[21] = t5;
        $[22] = t8;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== triggerProps) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, t13);
        $[24] = t13;
        $[25] = triggerProps;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ dynamicActionText: dynamicActionText, isDynamicActionSelected: isDynamicActionSelected = false, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: isInObjectSideBar = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar
        ],
        grow: "hug",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: !renderServerPlaceholder,
        exitThenEnter: true
    }, dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        entranceDirection: "right",
        exitDirection: "right",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            "data-vc": "ai-floating-dynamic-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: ()=>onDynamicActionClick?.(),
            xcss: [
                $7b40fa145aa0c9d8$var$defaultPressableStyles,
                isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles
            ]
        }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
        label: formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText),
        onClick: ()=>onMenuButtonClick?.(),
        appearance: "subtle",
        isSelected: isMenuOpen,
        shape: isInObjectSideBar ? 'circle' : 'default'
    })));
};














const $44548221e1617185$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $44548221e1617185$export$2593be7073434b2d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props || $[5] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
            ...props,
            ref: ref,
            role: "dialog"
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = ref;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog"
    }, children);
});















var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $1l0kj = parcelRequire("1l0kj");


var $9KSWX = parcelRequire("9KSWX");


var $3fO5l = parcelRequire("3fO5l");


var $gFEZF = parcelRequire("gFEZF");


var $eDtFr = parcelRequire("eDtFr");


var $5ZtfK = parcelRequire("5ZtfK");








var $c8mrj = parcelRequire("c8mrj");








var $jln20 = parcelRequire("jln20");


var $4aiCO = parcelRequire("4aiCO");


var $UNr39 = parcelRequire("UNr39");


const $790b3996dfce6541$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    audioSummarySectionLabel: {
        id: "ai-floating-context-menu.menu.item.label.audio-summary",
        defaultMessage: "Listen to Page Summary"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    betaLabel: {
        id: "ai-floating-context-menu.menu.item.lozenge.beta",
        defaultMessage: "Beta"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    createSectionLabel: {
        id: "ai-floating-context-menu.create.section.label",
        defaultMessage: "Create"
    }
});
var $790b3996dfce6541$var$ContentActionsMenuSectionKey = /*#__PURE__*/ function(ContentActionsMenuSectionKey) {
    ContentActionsMenuSectionKey["Summarize"] = "Summarize";
    ContentActionsMenuSectionKey["Create"] = "Create";
    return ContentActionsMenuSectionKey;
}($790b3996dfce6541$var$ContentActionsMenuSectionKey || {});
const $790b3996dfce6541$export$2b7899a440558a80 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { contentId: contentId, isLivePage: t1, setIsOpen: setIsOpen, setPopupState: setPopupState } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const isSidePanelOpen = t2 === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = typeof document !== "undefined" ? document.querySelector("div#content") : null;
        $[2] = t3;
    } else t3 = $[2];
    const content = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[3] !== contentId) {
        t4 = {
            contentId: contentId,
            content: content
        };
        $[3] = contentId;
        $[4] = t4;
    } else t4 = $[4];
    const handleBulkIssueCreate = (0, $c8mrj.useBulkIssueCreate)(t4);
    let t5;
    if ($[5] !== contentId || $[6] !== createAnalyticsEvent || $[7] !== edition || $[8] !== footerCommentsCount || $[9] !== handleBulkIssueCreate || $[10] !== intl || $[11] !== isLivePage || $[12] !== isSidePanelOpen || $[13] !== setIsOpen || $[14] !== setPopupState || $[15] !== showWarningDialog || $[16] !== unresolvedInlineCommentsCount) {
        const menuItems = [
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
                showMenuItem: true,
                isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
                label: intl.formatMessage((0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
                showMenuItem: (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation"),
                isDisabled: false,
                beta: false,
                section: "Create",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                })
            }
        ];
        const sectionItems = [
            {
                key: "Summarize",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showSection: menuItems.some($790b3996dfce6541$var$_temp)
            },
            {
                key: "Create",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
                showSection: !isLivePage && menuItems.some($790b3996dfce6541$var$_temp2)
            }
        ];
        const onMenuItemSelection = (key)=>{
            let additionalAnalyticsAttributes = {};
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
                numPageCommentsSummarized: footerCommentsCount,
                numInlineCommentsSummarized: unresolvedInlineCommentsCount
            };
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: `aiActionsMenuItem-${key}`,
                    attributes: {
                        contentId: contentId,
                        edition: edition,
                        ...additionalAnalyticsAttributes,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation")) {
                if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
                else {
                    setIsOpen(false);
                    handleBulkIssueCreate();
                }
            } else setPopupState(key);
        };
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            testId: "ai-uber-button-menu-group"
        }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                key: section.key,
                title: section.label
            }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    iconBefore: item_1.icon,
                    key: item_1.key,
                    isDisabled: item_1.isDisabled,
                    onClick: ()=>{
                        onMenuItemSelection(item_1.key);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center"
                }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
        $[5] = contentId;
        $[6] = createAnalyticsEvent;
        $[7] = edition;
        $[8] = footerCommentsCount;
        $[9] = handleBulkIssueCreate;
        $[10] = intl;
        $[11] = isLivePage;
        $[12] = isSidePanelOpen;
        $[13] = setIsOpen;
        $[14] = setPopupState;
        $[15] = showWarningDialog;
        $[16] = unresolvedInlineCommentsCount;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ contentId: contentId, isLivePage: isLivePage = false, setIsOpen: setIsOpen, setPopupState: setPopupState })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $c8mrj.useBulkIssueCreate)({
        contentId: contentId,
        content: content
    });
    const menuItems = [
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            showMenuItem: true,
            isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
            label: intl.formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation'),
            isDisabled: false,
            beta: false,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            })
        }
    ];
    const sectionItems = [
        {
            key: "Summarize",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showSection: menuItems.some((item)=>item.section === 'Summarize' && item.showMenuItem)
        },
        {
            key: "Create",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
            showSection: !isLivePage && menuItems.some((item_0)=>item_0.section === 'Create' && item_0.showMenuItem)
        }
    ];
    const onMenuItemSelection = (key)=>{
        let additionalAnalyticsAttributes = {};
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
            numPageCommentsSummarized: footerCommentsCount,
            numInlineCommentsSummarized: unresolvedInlineCommentsCount
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'menuItem',
                actionSubjectId: `aiActionsMenuItem-${key}`,
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    ...additionalAnalyticsAttributes,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) {
            if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
            else {
                setIsOpen(false);
                handleBulkIssueCreate();
            }
        } else setPopupState(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        testId: "ai-uber-button-menu-group"
    }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            key: section.key,
            title: section.label
        }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconBefore: item_1.icon,
                key: item_1.key,
                isDisabled: item_1.isDisabled,
                onClick: ()=>{
                    onMenuItemSelection(item_1.key);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "center"
            }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
};
function $790b3996dfce6541$var$_temp(item) {
    return item.section === "Summarize" && item.showMenuItem;
}
function $790b3996dfce6541$var$_temp2(item_0) {
    return item_0.section === "Create" && item_0.showMenuItem;
}















var $i1t43 = parcelRequire("i1t43");








var $5oPgz = parcelRequire("5oPgz");


var $auvZ1 = parcelRequire("auvZ1");


var $9VC5k = parcelRequire("9VC5k");


var $auLW1 = parcelRequire("auLW1");


var $eN3MW = parcelRequire("eN3MW");


var $brrvF = parcelRequire("brrvF");






const $0eb3a6f6be084bf0$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    aiFloatingContextMenuOptInDialogHeaderText: {
        id: "ai-floating-context-menu.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiFloatingContextMenuAdminOptInDialogBodyText: {
        id: "ai-floating-context-menu.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $0eb3a6f6be084bf0$var$FeatureContentWidthStyles = (0, $buxP3.xcss)({
    width: '500px'
});
const $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: t1 } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    let t2;
    if ($[0] !== adminLink || $[1] !== contentId || $[2] !== contentType || $[3] !== intl || $[4] !== isLivePage || $[5] !== lastModifiedDate || $[6] !== onClose || $[7] !== popupState || $[8] !== setIsOpen || $[9] !== setPopupState || $[10] !== source || $[11] !== spaceKey) {
        const formatOptInMessageValues = {
            a: $0eb3a6f6be084bf0$var$_temp,
            br: $0eb3a6f6be084bf0$var$_temp2
        };
        const renderContent = ()=>{
            switch(popupState){
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auvZ1.FooterCommentsSummaryCombined), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Header,
                        spaceKey: spaceKey
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: onClose,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate,
                        setIsOpen: onClose,
                        source: source,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                        source: "quickSummary",
                        product: "confluence",
                        isOrgAdmin: true,
                        headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                        adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                        adminLink: adminLink,
                        onAdminClose: ()=>setIsOpen(false)
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                        contentId: contentId,
                        setPopupState: setPopupState,
                        setIsOpen: setIsOpen,
                        isLivePage: isLivePage
                    });
            }
        };
        let t3;
        if ($[13] !== popupState) {
            t3 = (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles;
            $[13] = popupState;
            $[14] = t3;
        } else t3 = $[14];
        let t4;
        if ($[15] !== t3) {
            t4 = [
                t3
            ];
            $[15] = t3;
            $[16] = t4;
        } else t4 = $[16];
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t4
        }, renderContent());
        $[0] = adminLink;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = lastModifiedDate;
        $[6] = onClose;
        $[7] = popupState;
        $[8] = setIsOpen;
        $[9] = setPopupState;
        $[10] = source;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: isLivePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    const formatOptInMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
    };
    const renderContent = ()=>{
        switch(popupState){
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auvZ1.FooterCommentsSummaryCombined), {
                    contentId: contentId,
                    contentType: contentType,
                    source: (0, $9VC5k.CommentsSummarySource).Header,
                    spaceKey: spaceKey
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setIsOpen: onClose,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    setIsOpen: onClose,
                    source: source,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                    source: "quickSummary",
                    product: "confluence",
                    isOrgAdmin: true,
                    headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                    adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                    adminLink: adminLink,
                    onAdminClose: ()=>setIsOpen(false)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                    contentId: contentId,
                    setPopupState: setPopupState,
                    setIsOpen: setIsOpen,
                    isLivePage: isLivePage
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles
        ]
    }, renderContent());
});
function $0eb3a6f6be084bf0$var$_temp(s) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
        target: "_blank"
    }, s);
}
function $0eb3a6f6be084bf0$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null);
}



const $b3acdd5624bc36ae$var$absoluteWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    right: 'space.150',
    bottom: 'space.0'
});
const $b3acdd5624bc36ae$var$FloatingContextMenuStyles = null;
const $b3acdd5624bc36ae$var$dynamicActionTextMap = {
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).summarizeSectionLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).inlineCommentsMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).pageCatchupMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).bulkIssueCreateMenuItemLabel
};
const $b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate = '', pageCommentsSectionInView: pageCommentsSectionInView = false, isLivePage: isLivePage = false, isInObjectSideBar: isInObjectSideBar = false, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [popupState, setPopupState] = (0, $cozmU.useState)((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    const { dynamicActionTarget: dynamicActionTarget, queryError: queryError } = (0, $83cf8da53844c2d7$export$7571cdd921b49cc0)(contentId, contentType, pageCommentsSectionInView && !isLivePage, isLivePage, contentIdFromQuery, contentBodyDynamic);
    const { pulseCount: pulseCount } = (0, $874fd8abb2c90fe4$export$b938e63de8ec6cb1)(contentId, contentType);
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDynamicActionSelected = isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu; // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const isEnabled = isAIFeatureEnabled && (isAIEnabledForContent || isSiteAdmin && !isAdminHubAIEnabled || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !isAdminHubAIEnabled);
    const getDynamicActionText = ()=>{
        if (dynamicActionTarget && !isOpen) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[dynamicActionTarget]);
        else if (isOpen && (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState)) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[popupState]);
        else return undefined;
    };
    const [prevDynamicActionTarget, setPrevDynamicActionTarget] = (0, $cozmU.useState)(null);
    if (dynamicActionTarget !== prevDynamicActionTarget) {
        setPrevDynamicActionTarget(dynamicActionTarget);
        if (dynamicActionTarget) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                source: 'page',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    }, []);
    const onDynamicActionClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onClose();
        else if (dynamicActionTarget) {
            setIsOpen(true);
            setPopupState(dynamicActionTarget);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isOpen,
        onClose,
        dynamicActionTarget,
        isLivePage
    ]);
    const onMenuButtonClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && isAdminHubAIEnabled) setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
        else if (isOpen) onClose();
        else if (!isAdminHubAIEnabled && edition !== (0, $euL71.ConfluenceEdition).PREMIUM) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell);
        } else if (!isAdminHubAIEnabled && isSiteAdmin) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn);
        } else setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiActionMenuButton',
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        edition,
        isOpen,
        onClose,
        popupState,
        isAdminHubAIEnabled,
        isSiteAdmin,
        isLivePage
    ]);
    const popupComponent = ()=>{
        if (popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu) return 0, $44548221e1617185$export$2593be7073434b2d;
        return 0, $NomII.CustomPopupContainer;
    };
    if (!isEnabled) return null;
    if (isAdminHubAIEnabled && (0, $6mKj3.expVal)('confluence_clean_up_legacy_ai_button', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        offset: [
            0,
            6
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a), {
                popupState: popupState,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                lastModifiedDate: lastModifiedDate ?? '',
                source: "view-page",
                onClose: onClose,
                setPopupState: setPopupState,
                setIsOpen: setIsOpen,
                isLivePage: isLivePage
            }),
        shouldRenderToParent: true,
        placement: "top-end",
        popupComponent: popupComponent(),
        zIndex: popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && (0, $9wGTI.fg)('platform-dst-motion-uplift-popup') ? 1 : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af25143620373faf$export$cd20eff28c3c2c7f), {
                pulseCount: pulseCount,
                isInObjectSideBar: isInObjectSideBar
            }, !isAdminHubAIEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ExetK.AIButton), {
                ...triggerProps,
                onClick: onMenuButtonClick
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b40fa145aa0c9d8$export$c226a072142c15e9), {
                isDynamicActionSelected: isDynamicActionSelected,
                triggerProps: triggerProps,
                onMenuButtonClick: onMenuButtonClick,
                onDynamicActionClick: onDynamicActionClick,
                dynamicActionText: getDynamicActionText(),
                isMenuOpen: isOpen && popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu,
                isInObjectSideBar: isInObjectSideBar
            }))
    }));
};
const $b3acdd5624bc36ae$export$71951c424ee8d4c2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "ai-floating-context-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, props.isInObjectSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $b3acdd5624bc36ae$var$absoluteWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _0Bm75Gp0Oa _42Yu6B3p0A _1VJPcaIt9z"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props))))));
};
module.exports["AIFloatingContextMenu"] = $b3acdd5624bc36ae$export$71951c424ee8d4c2;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

/**
 * @graphql cc
 */ 



var $4L9ve = parcelRequire("4L9ve");

const $c085ac79a8833850$export$453b7c79178856e5 = (_contentId)=>{
    // Get processed comment data from the Comments Data Manager store
    const { isDataProcessed: isDataProcessed, openInlineComments: openInlineComments, openFooterComments: openFooterComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    return (0, $cozmU.useMemo)(()=>{
        if (isDataProcessed) return {
            unresolvedInlineCommentsCount: openInlineComments.length,
            footerCommentsCount: openFooterComments.length
        };
        // Fallback when data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        isDataProcessed,
        openInlineComments.length,
        openFooterComments.length
    ]);
};


const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $cozmU.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $c085ac79a8833850$export$453b7c79178856e5)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $c085ac79a8833850$export$453b7c79178856e5)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("c8mrj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $UNr39 = parcelRequire("UNr39");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content, useRovoWidth: useRovoWidth = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsRovoPanelWidth = (0, $hq2Sz.useSetIsRovoPanelWidth)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $cozmU.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $cozmU.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        setIsRovoPanelWidth(useRovoWidth);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), useRovoWidth ? (0, $UNr39.ROVO_BULK_CREATE_SIDE_PANEL_WIDTH) : (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsRovoPanelWidth,
        useRovoWidth,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};
module.exports["useBulkIssueCreate"] = $c8e282bfad3727e4$export$ddc739fc0aea988a;

});

parcelRegister("auvZ1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $6654dd6aa1f8b471$export$33b519b7db786337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9WcCJ",
    name: "FooterCommentsSummaryCombined",
    loader: async ()=>(await (parcelRequire("cGlMo"))).FooterCommentsSummaryCombinedWithErrorBoundary
});
module.exports["FooterCommentsSummaryCombined"] = $6654dd6aa1f8b471$export$33b519b7db786337;

});

parcelRegister("cGlMo", function(module, exports) {

let $93ba4d3888fcc884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93ba4d3888fcc884$var$load("5lfr5").then(()=>parcelRequire('ebALC'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("9VC5k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $7akNQ = parcelRequire("7akNQ");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $cXLoX = parcelRequire("cXLoX");















var $a9aSv = parcelRequire("a9aSv");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


const $96aaefbcbab4ea71$export$b58d43d92d088553 = ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4473 7.99998C11.4473 7.63179 11.7457 7.33331 12.1139 7.33331H13.3339C13.7021 7.33331 14.0006 7.63179 14.0006 7.99998C14.0006 8.36817 13.7021 8.66665 13.3339 8.66665H12.1139C11.7457 8.66665 11.4473 8.36817 11.4473 7.99998Z",
        fill: "url(#paint0_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 2C8.36884 2 8.66732 2.29848 8.66732 2.66667V3.88667C8.66732 4.25486 8.36884 4.55333 8.00065 4.55333C7.63246 4.55333 7.33398 4.25486 7.33398 3.88667V2.66667C7.33398 2.29848 7.63246 2 8.00065 2Z",
        fill: "url(#paint1_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 7.99998C2 7.63179 2.29848 7.33331 2.66667 7.33331H3.88667C4.25486 7.33331 4.55333 7.63179 4.55333 7.99998C4.55333 8.36817 4.25486 8.66665 3.88667 8.66665H2.66667C2.29848 8.66665 2 8.36817 2 7.99998Z",
        fill: "url(#paint2_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 11.4467C8.36884 11.4467 8.66732 11.7451 8.66732 12.1133V13.3333C8.66732 13.7015 8.36884 14 8.00065 14C7.63246 14 7.33398 13.7015 7.33398 13.3333V12.1133C7.33398 11.7451 7.63246 11.4467 8.00065 11.4467Z",
        fill: "url(#paint3_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.52925 9.52858C9.7896 9.26823 10.2117 9.26823 10.4721 9.52858L13.1387 12.1952C13.3991 12.4556 13.3991 12.8777 13.1387 13.1381C12.8784 13.3984 12.4563 13.3984 12.1959 13.1381L9.52925 10.4714C9.2689 10.211 9.2689 9.78892 9.52925 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.1387 2.86195C13.3991 3.1223 13.3991 3.54441 13.1387 3.80476L10.4721 6.47142C10.2117 6.73177 9.7896 6.73177 9.52925 6.47142C9.2689 6.21108 9.2689 5.78897 9.52925 5.52862L12.1959 2.86195C12.4563 2.6016 12.8784 2.6016 13.1387 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.86128 2.86195C3.12163 2.6016 3.54374 2.6016 3.80409 2.86195L6.47075 5.52862C6.7311 5.78897 6.7311 6.21108 6.47075 6.47142C6.2104 6.73177 5.78829 6.73177 5.52794 6.47142L2.86128 3.80476C2.60093 3.54441 2.60093 3.1223 2.86128 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.47075 9.52858C6.7311 9.78892 6.7311 10.211 6.47075 10.4714L3.80409 13.1381C3.54374 13.3984 3.12163 13.3984 2.86128 13.1381C2.60093 12.8777 2.60093 12.4556 2.86128 12.1952L5.52794 9.52858C5.78829 9.26823 6.2104 9.26823 6.47075 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_2378_7139",
        x1: "14.0006",
        y1: "7.99998",
        x2: "11.6672",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.270833",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_2378_7139",
        x1: "8.33398",
        y1: "2",
        x2: "8.33398",
        y2: "4.33333",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1875",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_2378_7139",
        x1: "4.5533",
        y1: "7.99998",
        x2: "2.21997",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.791667",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_2378_7139",
        x1: "8.33398",
        y1: "11.3333",
        x2: "8.33398",
        y2: "14",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.802083",
        stopColor: "#2684FF"
    }))));


const $333270f2f5cd2de3$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummary: {
        id: "ai-skeleton-loading.title",
        defaultMessage: "Atlassian Intelligence is generating a summary..."
    },
    logoAltText: {
        id: "ai-skeleton-loading.logo-alt",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});
const $333270f2f5cd2de3$var$loadingTextContainer = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.200',
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $333270f2f5cd2de3$export$e93f99a4d30f6d75 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $333270f2f5cd2de3$var$loadingTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96aaefbcbab4ea71$export$b58d43d92d088553), {
        alt: intl.formatMessage($333270f2f5cd2de3$var$i18n.logoAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, intl.formatMessage($333270f2f5cd2de3$var$i18n.generatingSummary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    })));
};



var $lpJCW = parcelRequire("lpJCW");















var $7m1U4 = parcelRequire("7m1U4");

const $82345f9002994123$var$BoxStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: 'radius.large',
    borderBottomLeftRadius: 'radius.small'
});
const $82345f9002994123$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $82345f9002994123$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $82345f9002994123$var$BoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82345f9002994123$var$i18n.generatingSummaryText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($82345f9002994123$var$i18n.generatingSummaryAnimationAlt)
    })));
};



var $5GgqH = parcelRequire("5GgqH");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $3Am3T = parcelRequire("3Am3T");


var $8jP1I = parcelRequire("8jP1I");

var $161368acfff8028f$export$ec72d0267c37019f = /*#__PURE__*/ function(CommentsSummaryAnalyticsType) {
    CommentsSummaryAnalyticsType["FOOTER"] = "FOOTER";
    CommentsSummaryAnalyticsType["INLINE"] = "INLINE";
    return CommentsSummaryAnalyticsType;
}({});



var $dchHi = parcelRequire("dchHi");


var $bbNJt = parcelRequire("bbNJt");


var $jhwJP = parcelRequire("jhwJP");

/**
 * @generated SignedSource<<29553362f1cef877309db445c48df90d>>
 * @relayHash 53eb9fa8cec0a522c06e9697c10f440b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33
const $24226cfbd28917e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "53eb9fa8cec0a522c06e9697c10f440b",
            "id": "0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$24226cfbd28917e5$var$node.hash = "6db2d91039b90f64f08e4e052c0a32d7";
var $24226cfbd28917e5$export$2e2bcd8739ae039 = $24226cfbd28917e5$var$node;


/**
 * @generated SignedSource<<c4777a9cf5f8e5b40c54145fa6f43328>>
 * @relayHash dc798cc8cc74b72655c7a19090058c0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb
const $050fce5e42c00d97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "dc798cc8cc74b72655c7a19090058c0e",
            "id": "436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$050fce5e42c00d97$var$node.hash = "ffce51d12c39ccd238d2cb848107c61a";
var $050fce5e42c00d97$export$2e2bcd8739ae039 = $050fce5e42c00d97$var$node;



var $jMyy4 = parcelRequire("jMyy4");

/**
 * @generated SignedSource<<1f05a50a15753c67b4b42e99a5cdfd85>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $ac5fc6262abb25ff$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $ac5fc6262abb25ff$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["PAGE"] = "PAGE";
    SummaryType["BLOGPOST"] = "BLOGPOST";
    return SummaryType;
}({});


const $0edd62bded09ab4f$export$7bdbf0c72871fa1f = ({ contentId: contentId, contentType: contentType, shouldSkipFooterCommentsQuery: shouldSkipFooterCommentsQuery = false, shouldSkipInlineCommentsQuery: shouldSkipInlineCommentsQuery = false })=>{
    const { data: footerCommentsSummaryData, loading: footerCommentsQueryLoading, error: footerCommentsSummaryError, refetch: footerCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $050fce5e42c00d97$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).FOOTER
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipFooterCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const { data: inlineCommentsSummaryData, loading: inlineCommentsQueryLoading, error: inlineCommentsSummaryError, refetch: inlineCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $24226cfbd28917e5$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).INLINE
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipInlineCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const refetch = ()=>{
        footerCommentsRefetch();
        inlineCommentsRefetch();
    };
    return {
        data: {
            footerCommentsSummaryData: footerCommentsSummaryData,
            inlineCommentsSummaryData: inlineCommentsSummaryData
        },
        loading: footerCommentsQueryLoading || inlineCommentsQueryLoading,
        errors: {
            footerCommentsSummaryError: footerCommentsSummaryError,
            inlineCommentsSummaryError: inlineCommentsSummaryError
        },
        refetch: refetch
    };
};


const $ea0c56ea9695a839$export$2f5736e19049ec78 = '775fa156-8bed-4310-af75-c6d1148b88fb';


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $17fd4a0f0d6084c8$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $17fd4a0f0d6084c8$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["BLOGPOST"] = "BLOGPOST";
    SummaryType["PAGE"] = "PAGE";
    return SummaryType;
}({});



var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $f6bfaf9677f19070$export$9ad53c330569860e = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.COMMENTS_SUMMARY_COMPONENT_INTERACTION)
});


// eslint-disable-next-line import/order







var $i1t43 = parcelRequire("i1t43");











var $6Pqow = parcelRequire("6Pqow");





var $b3j2Y = parcelRequire("b3j2Y");


var $dL3KX = parcelRequire("dL3KX");


var $53ZHq = parcelRequire("53ZHq");

















var $7Sm4c = parcelRequire("7Sm4c");








const $883f6dcc92761560$export$37675c48b66aa091 = (contentId, source, footerCommentsError, inlineCommentsError)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { errorType: footerCommentsErrorType, isExpectedError: footerCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), footerCommentsError);
    const { errorType: inlineCommentsErrorType, isExpectedError: inlineCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), inlineCommentsError);
    const { errorType: errorType, commentsType: commentsType } = (0, $cozmU.useMemo)(()=>{
        let memoErrorType;
        let memoCommentsType = [];
        if (footerCommentsError && inlineCommentsError) {
            if (footerCommentsErrorType === inlineCommentsErrorType) memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER,
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        } else if (footerCommentsError) {
            memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER
            ];
        } else if (inlineCommentsError) {
            memoErrorType = inlineCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        }
        return {
            errorType: memoErrorType || (0, $dL3KX.HandledErrorType).GeneralError,
            commentsType: memoCommentsType
        };
    }, [
        inlineCommentsError,
        inlineCommentsErrorType,
        footerCommentsError,
        footerCommentsErrorType
    ]);
    if (footerCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(footerCommentsError);
    if (inlineCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(inlineCommentsError);
    // Experience should only be a failure if both queries have erred
    // OR either query has failed when the other query was skipped due to 0 comments
    const isExperienceFailure = footerCommentsError && (inlineCommentsError || unresolvedInlineCommentsCount === 0) || inlineCommentsError && footerCommentsCount === 0;
    const isExpectedError = footerCommentsIsExpectedError && (inlineCommentsIsExpectedError || unresolvedInlineCommentsCount === 0) || inlineCommentsIsExpectedError && footerCommentsCount === 0;
    if (isExperienceFailure) {
        if (isExpectedError) experienceTracker.abort({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            reason: `Can not generate summary due to ${errorType}`,
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        else // Experience tracker can only fail with a single error. Since both queries have failed we will use the footer
        // comments failure to end the experience and pass both types of failures as attributes for further debugging
        experienceTracker.fail({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            // TS does not interpret the isExperienceFailure logic above correctly. Letting the compiler know
            error: footerCommentsError || inlineCommentsError,
            attributes: {
                footerCommentsErrorType: footerCommentsErrorType,
                inlineCommentsErrorType: inlineCommentsErrorType
            }
        });
    }
    return {
        erredQueries: commentsType,
        errorType: errorType,
        shouldCallErrorDisplayForFooterComments: !!footerCommentsError && !footerCommentsIsExpectedError,
        shouldCallErrorDisplayForInlineComments: !!inlineCommentsError && !inlineCommentsIsExpectedError
    };
};


const $6a674942f4f35f24$var$textStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $6a674942f4f35f24$var$i18nBase = (0, $kSwu1.defineMessages)({
    combinedErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-general",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a summary right now. You can try again later or read more <a>in our support documentation</a>."
    },
    combinedErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-much-content",
        defaultMessage: "There are too many comments for Atlassian Intelligence (AI) to summarize. Try again on content with fewer comments."
    },
    combinedErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-little-content",
        defaultMessage: "There aren\u2019t enough comments for Atlassian Intelligence (AI) to summarize. Try again when more comments have been added."
    },
    combinedErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-rate-limit",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    combinedErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-aup-violation",
        defaultMessage: "Atlassian Intelligence (AI) can\u2019t provide a summary of the comments on this content, as some comments may not comply with our <a>Acceptable Use Policy</a>."
    },
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general",
        defaultMessage: "There is no summary of page comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content",
        defaultMessage: "This summary only includes inline comments, as there are too many page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many page comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation",
        defaultMessage: "This summary only includes inline comments, as some page comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-general",
        defaultMessage: "There is no summary of inline comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content",
        defaultMessage: "This summary only includes page comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content",
        defaultMessage: "This summary only includes page comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit",
        defaultMessage: "This summary only includes page comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation",
        defaultMessage: "This summary only includes page comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general.livedocs",
        defaultMessage: "There is no summary of general comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there are too many general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many general comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes inline comments, as some general comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes general comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes general comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($6a674942f4f35f24$var$i18nBase, $6a674942f4f35f24$var$i18nLiveDocs);
const $6a674942f4f35f24$export$b0cd94004126f4ff = ({ contentId: contentId, footerCommentsError: footerCommentsError, inlineCommentsError: inlineCommentsError, source: source })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { erredQueries: erredQueries, errorType: errorType, shouldCallErrorDisplayForFooterComments: shouldCallErrorDisplayForFooterComments, shouldCallErrorDisplayForInlineComments: shouldCallErrorDisplayForInlineComments } = (0, $883f6dcc92761560$export$37675c48b66aa091)(contentId, source, footerCommentsError, inlineCommentsError);
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    (0, $cozmU.useEffect)(()=>{
        trackAIResultError({
            aiErrorMessage: errorType,
            // TODO Ideally we should pass the real code from the response
            aiErrorCode: 400
        }, {
            attributes: {
                contentId: contentId,
                errorType: errorType,
                commentsType: erredQueries,
                source: source
            }
        });
    }, [
        erredQueries,
        contentId,
        trackAIResultError,
        errorType,
        source
    ]);
    const onDocsLinkClicked = (linkName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'commentsSummaryError',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkName}DocsLink`,
                attributes: {
                    contentId: contentId,
                    errorType: errorType,
                    commentsType: erredQueries,
                    source: source
                }
            }
        }).fire();
    };
    const errorMessage = ()=>{
        let i18nPrefix = "combined";
        if (footerCommentsError && !inlineCommentsError && unresolvedInlineCommentsCount > 0) i18nPrefix = "footerComments";
        if (inlineCommentsError && !footerCommentsError && footerCommentsCount > 0) i18nPrefix = "inlineComments";
        switch(errorType){
            case (0, $dL3KX.HandledErrorType).TooMuchContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorTooMuchContent`]);
            case (0, $dL3KX.HandledErrorType).NotEnoughContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorNotEnoughContent`]);
            case (0, $dL3KX.HandledErrorType).AUPViolation:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorAUPViolation`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.ACCEPTABLE_USE_POLICY_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('AupViolation')
                        }, chunks)
                });
            case (0, $dL3KX.HandledErrorType).RateLimit:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorRateLimit`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.USAGE_LIMITS_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('RateLimit')
                        }, chunks)
                });
            default:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorGeneral`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.TROUBLE_SHOOTING_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('Troubleshooting')
                        }, chunks)
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $6a674942f4f35f24$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, errorMessage()), footerCommentsError && shouldCallErrorDisplayForFooterComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: footerCommentsError
    }), inlineCommentsError && shouldCallErrorDisplayForInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: inlineCommentsError
    }));
};


const $28602bba7ed7c957$var$styles = (0, $buxP3.xcss)({
    height: '100%',
    font: 'font.body.large'
});
const $28602bba7ed7c957$var$FooterObjectSidebarStyles = (0, $buxP3.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $28602bba7ed7c957$var$i18nBase = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header",
        defaultMessage: "Page comments"
    },
    inlineCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.inline-comments-header",
        defaultMessage: "Inline comments"
    }
});
const $28602bba7ed7c957$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header.livedocs",
        defaultMessage: "General comments"
    }
});
const $28602bba7ed7c957$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($28602bba7ed7c957$var$i18nBase, $28602bba7ed7c957$var$i18nLiveDocs);
var $28602bba7ed7c957$export$92985523ee81b88c = /*#__PURE__*/ function(CommentsSummarySource) {
    CommentsSummarySource["Footer"] = "footer";
    CommentsSummarySource["Header"] = "header";
    CommentsSummarySource["Feed"] = "feed";
    return CommentsSummarySource;
}({});
const $28602bba7ed7c957$export$dd076aaa63869f66 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, onRefresh: onRefresh, shouldRefetchCommentsSummary: shouldRefetchCommentsSummary = false, source: source, isInObjectSidebar: isInObjectSidebar, showAIDisclaimer: showAIDisclaimer = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cXLoX.useAIEventsInstrumentation)();
    const containerRef = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(containerRef);
    const contentTypeEnum = contentType === 'page' ? (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).PAGE : (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).BLOGPOST;
    const { data: data, errors: errors, loading: loading, refetch: refetch } = (0, $0edd62bded09ab4f$export$7bdbf0c72871fa1f)({
        contentId: contentId,
        contentType: contentTypeEnum,
        shouldSkipFooterCommentsQuery: footerCommentsCount === 0,
        shouldSkipInlineCommentsQuery: unresolvedInlineCommentsCount === 0
    });
    const refreshHandler = ()=>{
        if (!loading) {
            refetch();
            onRefresh?.();
        }
    };
    const startExperienceTracking = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        (0, $f6bfaf9677f19070$export$9ad53c330569860e).start();
    }, [
        contentId,
        experienceTracker,
        source
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (loading) startExperienceTracking();
        if (!loading) (0, $f6bfaf9677f19070$export$9ad53c330569860e).stop();
    }, [
        loading,
        startExperienceTracking
    ]);
    const footerCommentsSummary = data.footerCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const inlineCommentsSummary = data.inlineCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const loadingRef = (0, $cozmU.useRef)(loading);
    (0, $cozmU.useEffect)(()=>{
        loadingRef.current = loading;
    }, [
        loading
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
        if (shouldRefetchCommentsSummary) {
            refetch();
            onRefresh?.();
        }
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'commentsSummary',
                    source: 'commentsSummary',
                    actionSubjectId: 'commentsSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        dwellTime: getDwellTime()
                    }
                }
            }).fire();
            if (loadingRef.current) trackAIInteractionDismiss();
        };
    // Only check auto refetch on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const summaryLocale = (0, $cozmU.useMemo)(()=>{
        // Ok to just choose first of whichever is available from data team
        return data.footerCommentsSummaryData?.getCommentsSummary?.language || data.inlineCommentsSummaryData?.getCommentsSummary?.language;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const commentsType = (0, $cozmU.useMemo)(()=>{
        const commentsTypeCollection = [];
        if (data.footerCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).FOOTER);
        if (data.inlineCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).INLINE);
        return commentsTypeCollection;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const feedbackContext = {
        commentsType: commentsType,
        source: source
    };
    const analyticsProperties = {
        source: 'commentsSummary',
        additionalAnalyticsAttributes: {
            commentsType: commentsType
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (!loading) {
            if (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'commentsSummaryContainer',
                        attributes: {
                            contentId: contentId,
                            edition: edition,
                            commentsType: commentsType,
                            summaryLocale: summaryLocale,
                            numPageCommentsSummarized: footerCommentsCount,
                            numInlineCommentsSummarized: unresolvedInlineCommentsCount
                        }
                    }
                }).fire();
                trackAIResultView();
            }
        }
    }, [
        createAnalyticsEvent,
        contentId,
        edition,
        loading,
        commentsType,
        summaryLocale,
        errors.footerCommentsSummaryError,
        errors.inlineCommentsSummaryError,
        footerCommentsCount,
        trackAIResultView,
        unresolvedInlineCommentsCount
    ]);
    const fullTextToCopy = ()=>{
        return `${footerCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)}\n${footerCommentsSummary}`}\n\n${inlineCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)}\n${inlineCommentsSummary}`}`;
    };
    const renderContentBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.200"
        }, inlineCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, inlineCommentsSummary)), footerCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, footerCommentsSummary)), (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        }), (errors.footerCommentsSummaryError || errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a674942f4f35f24$export$b0cd94004126f4ff), {
            contentId: contentId,
            footerCommentsError: errors.footerCommentsSummaryError,
            inlineCommentsError: errors.inlineCommentsSummaryError,
            source: source
        }));
    };
    const renderContent = ()=>{
        if (loading) return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82345f9002994123$export$dd8c26521b6a2fec), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $333270f2f5cd2de3$export$e93f99a4d30f6d75), null);
        const shouldShowFooterError = !!errors.footerCommentsSummaryError && !!errors.inlineCommentsSummaryError || !!errors.footerCommentsSummaryError && inlineCommentsSummary.length === 0 || !!errors.inlineCommentsSummaryError && footerCommentsSummary.length === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            xcss: $28602bba7ed7c957$var$styles,
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            padding: isInObjectSidebar ? 'space.100' : 'space.250'
        }, source !== "footer" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bbNJt.SummaryPopupScrollableBody), {
            "data-testid": "scrollable-comments-summary"
        }, renderContentBody()) : renderContentBody()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: isInObjectSidebar && $28602bba7ed7c957$var$FooterObjectSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jP1I.AISummaryFooter), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            error: shouldShowFooterError,
            summaryText: fullTextToCopy(),
            showBetaLozenge: true,
            shouldHighlightRefresh: shouldRefetchCommentsSummary,
            refreshHandler: refreshHandler,
            showAIDisclaimer: showAIDisclaimer
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
        entrypointId: (0, $ea0c56ea9695a839$export$2f5736e19049ec78),
        feedbackContext: feedbackContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "comments-summary-content",
        hold: loading
    }), isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
        loading: loading
    }, renderContent()))));
};
module.exports["CommentsSummarySource"] = $28602bba7ed7c957$export$92985523ee81b88c;
module.exports["CommentsSummaryContent"] = $28602bba7ed7c957$export$dd076aaa63869f66;

});


//# sourceMappingURL=ObjectSidebarControl.c6be838e.js.map
